import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { memo } from 'react';
export const ColumnBox = memo(function ColumnBox(props) {
    const { children, ...rest } = props;
    return (_jsx(Box, { display: "flex", flexDirection: "column", gap: 2, ...rest, children: children }));
});
